import { IInitialState } from "../../hooks/types";

export const initialState: IInitialState = {
    theme: {},
    themeString: "",
    context: {},
    inTeams: false,
    teamsToken: "",
    authToken: "",
    tokenAPIStatus: "",
    personToken: "",
    errorMessage: "",
    hostConfig: {}
}